import React from "react";
import Skeleton from "@mui/material/Skeleton";
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

export default function () {
    return <React.Fragment>
        {[...Array(5)].map((index) => {
            return <TimelineItem key={index}>
                <TimelineOppositeContent>
                    <Skeleton variant="circular" width={40} height={40} />
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <Skeleton variant="circular" width={10} height={10} sx={{mb: 1}}/>
                    <TimelineConnector  sx={{mb: 1}}/>
                </TimelineSeparator>
                <TimelineContent sx={{ p: 0, pb: 5 }}>
                    <Skeleton height={20} width={100} />
                    <Skeleton height={20} width={200} />
                </TimelineContent>
            </TimelineItem>
        })}
    </React.Fragment>
}